import React from 'react'

import { getProjectNames, hasAccessToThis } from 'services/Utilities'
import { Card } from 'ui'
import { t } from 'translations'

const UserProjectRestrictions = ({ short, projectRestrictions }) => {
  const { blocked, locked, preferred } = projectRestrictions
  if (!hasAccessToThis('projectSee')) return t('components.MISSING_PERMISSIONS')

  if (short) {
    if (!blocked && !locked && !preferred) return null

    return (
      <div className="d-flex flex-column">
        {blocked ? <div>{getProjectNames(blocked, { delimiter: ', ' })}</div> : null}
        {locked ? <div>{getProjectNames(locked, { delimiter: ', ' })}</div> : null}
        {preferred ? <div>{getProjectNames(preferred, { delimiter: ', ' })}</div> : null}
      </div>
    )
  }

  return (
    <div className="mb-3">
      {<h5>{t('manager.users.form.PROJECT_RESTRICTION.TITLE')}</h5>}
      <small>{t('manager.users.form.PROJECT_RESTRICTION.CHANGES_MADE_IN_PROJECTS')}</small>
      {(blocked && blocked.length) || (locked && locked.length) || (preferred && preferred.length) ? (
        <Card className="bg-light">
          <div className="d-flex flex-column p-3">
            {blocked && blocked.length ? (
              <div>
                <b>{t('manager.users.form.PROJECT_RESTRICTION.BLOCKED')} </b>
                {getProjectNames(blocked, { delimiter: ', ' })}
              </div>
            ) : null}
            {locked && locked.length ? (
              <div>
                <b>{t('manager.users.form.PROJECT_RESTRICTION.LOCKED')} </b>
                {getProjectNames(locked, { delimiter: ', ' })}
              </div>
            ) : null}
            {preferred && preferred.length ? (
              <div>
                <b>{t('manager.users.form.PROJECT_RESTRICTION.PREFFERED')} </b>
                {getProjectNames(preferred, { delimiter: ', ' })}
              </div>
            ) : null}
          </div>
        </Card>
      ) : null}
    </div>
  )
}

export default UserProjectRestrictions
